define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/def/Action",
    "csi/def/Toolbar",
    "csi/reflection",
    "csi/siteDefaultLocale",
    "csi/table/Widget",
    "./ToolbarPluginLocalizedItem"
], function(declare,lang,Action,Toolbar,reflection,Locale,Widget,ToolbarPluginLocalizedItem) {

    return declare(Widget, {

        _resolveView: function() {
            this.inherited(arguments);
            const view = this.defView;

            view.defToolbar ||= lang.mixin(new Toolbar(), {
                m_actions: [
                    lang.mixin(new Action(), {
                        m_id: "SwitchLocale",
                        classToolbarPlugin: ToolbarPluginLocalizedItem
                    })
                ]
            });
        },

        isConfigurable: function(/*Controller*/ac) {
            // summary: is the node Configurable
            if (ac) {
                var node = ac.getNode();
                var rc = reflection.getNodeClass(node);
                return rc && rc.isDerivedFrom("Configurable");
            }

            return false;
        },

		postAction: function(/*Controller*/ac, /*Boolean*/bPendingAction) {
			// summary: update the whole row if we are changing a settings attribute
			if (this.isValidView()) {
				if (this.isConfigurable(ac) && ac.endStatus && !ac.bRefreshNode) {
					// FIX: We should be relying on Notify constraint to update Modified attribute and refresh the table row;
					// this code may no longer be needed now that we refresh automatically when there is a Notify constraint,
					// but for now adding extra checks to make sure no errors
					const refNode = this.getRefNode(ac.refNode || ac.m_element);
					if (refNode) {
						var node = ac.getNode();
						if (!node.Modified) {
							node.Modified = true;
							this.redrawNode(refNode);
						}
					}
				}
			}

			return this.inherited(arguments);
		},

        /**
         * @override
         * Load the locale resolver corresponding to the selected locale in the switchboard (localStore.editLocale)
         * Needed to support the DisplayName renderer in the SelectSetSubtypes table 
         */
        onBuildDeferreds(ctx, dfds) {
            dfds.push(Locale.loadEditResolvers());
        },
	});
});